import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../../StoreComponents/hooks/useStoreLog";

const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const ViewList = () => {
  const { cat_id } = useParams();
  const [limit, setLimit] = useState(50);
  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  const { data: categoryOption, error: error1 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10}`,
    fetcher
  );
  const [selectedCategory, setSelectedCategory] = useState("");
  // react hook form

  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  const {
    data: CategoryListData,
    error,
    mutate,
  } = useSWR(
    cat_id
      ? `store/settings/productByCatId/${cat_id}?page=${pageIndex}&limit=${limit}`
      : null,
    fetcher
  );

  //  DELETE Product

  const deleteButtonHandler = (Id) => {
    // console.log(Id);
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.delete("store/settings/products", {
          headers: {
            prodid: Id,
          },
        }).then((res) => {
          if (res) {
            PostStoreLog(3, "product name delete");
            mutate();
          }
        });

        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  // Update Section
  const [getId, setGetId] = useState(null);

  //   Update supliers
  const onSubmitUpdate = (data) => {
    if (selectedCategory) {
      data.procate = parseInt(selectedCategory);
    } else {
      data.procate = productById.PROCATE;
    }
    if (!data.proname) {
      data.proname = productById.PRONAME;
    }
    if (!data.pronametwo) {
      data.pronametwo = productById.PRONAMETWO;
    }

    console.log(data);

    API.put("store/settings/products", data, {
      headers: {
        prodid: getId,
      },
    }).then((res) => {
      //console.log(res.data);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "product name update");
        window.$("#edit_product_list").modal("hide");
        window.location.reload();
        reset1();
        mutate();
      }
    });
  };
  // Get suplier Id
  const handleUpdate = (updateId) => {
    // console.log(updateId);
    setGetId(updateId);
  };
  const handleCategory = (name) => {
    // console.log(name.value);
    setSelectedCategory(name.value);
  };
  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }
  // get product Data By ID
  const { data: productById } = useSWR(
    getId ? `store/settings/product/${getId}` : null,
    fetcher
  );

  console.log(productById);

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/settings/productByCatId/${cat_id}?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };
  const navigate = useNavigate();
  // console.log(productById);
  let counter = 1;
  return (
    <>
      <Helmet>
        <title>Products - BBA STORE</title>
        <meta name="description" content="Products - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Manage Category Wise Products
            </h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div_store">
              <div className="col-12 col-md-6 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries :
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <input
                  className="p-2 input-field w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  // onChange={(e) => {
                  //   setSearch(e.target.value);
                  // }}
                  placeholder="Search product"
                />
              </div>
            </div>
            {!CategoryListData ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="2">ID No.</th>
                      <th colSpan="2">Bangla</th>
                      <th colSpan="2">English</th>
                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {CategoryListData.map((item) => (
                      <tr key={counter}>
                        <th>{counter++}</th>
                        <td colSpan="2">SP{item.prodid}</td>
                        <td colSpan="2">{item.proname}</td>
                        <td colSpan="2">{item.pronametwo}</td>
                        <td className="text-center">
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            type="button"
                            data-toggle="modal"
                            data-target="#edit_product_list"
                            onClick={() => {
                              handleUpdate(item.prodid);
                            }}
                            className="btn btn-outline-color_store px-3 me-2"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            data-bs-toggle="tooltip"
                            title="Delete"
                            type="button"
                            onClick={() => {
                              deleteButtonHandler(item.prodid);
                            }}
                            className="btn btn-red_store px-3"
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {CategoryListData && CategoryListData.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Edit product list Modal */}
      <div
        id="edit_product_list"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Product</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                <div className="container px-4">
                  <div className="row mx-3">
                    <div className="col-sm-12 col-md-12 col-lg-12  data-table_store">
                      <Select
                        onChange={handleCategory}
                        style={{ borderRadius: "10px" }}
                        placeholder={
                          productById
                            ? `${productById.CATEGORYEN} (${productById.CATEGORYBN})`
                            : ""
                        }
                        className="text-start"
                        options={category}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table my-3">
                      <input
                        {...register1("pronametwo")}
                        defaultValue={productById ? productById.PRONAMETWO : ""}
                        type="text"
                        className="p-2 input-field_store"
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table_store my-3">
                      <input
                        {...register1("proname")}
                        defaultValue={productById ? productById.PRONAME : ""}
                        type="text"
                        className="p-2 input-field_store"
                      />
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewList;
